import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import { Header } from './components/header';
import { Sidebar } from './components/sidebar';

export const GlobalLayout = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Layout>
        <Sidebar />
        <Outlet />
      </Layout>
    </Layout>
  );
};
